export enum DefaultHardwareNodeDisplay {
  x1 = -45,
  y1 = 25,
}
